import { useV2ListServiceEstimateAccuraciesQuery } from "@generated";

// Same swagger omission as useListServiceEstimateAccuracies - see the note
// there.
type PagedResponse = { meta?: { "record-count"?: number } };

/**
 * How many services are actually worth acting on, for the Review tab's count.
 *
 * The list itself shows `none` rows too - "we looked at 14 deliveries and
 * found no consistent bias" is a real answer - but counting them in the tab
 * title would overstate what needs attention. Asks for a single record and
 * reads only the meta.
 */
const useCountFlaggedServices = ({ skip = false }: { skip?: boolean } = {}) => {
  const { data } = useV2ListServiceEstimateAccuraciesQuery(
    { filter: { direction: ["over", "under"] }, page: { number: 1, size: 1 } },
    { skip }
  );

  return (data as PagedResponse | undefined)?.meta?.["record-count"] ?? null;
};

export default useCountFlaggedServices;
